<template>
    <div class="container-fluid" >

        <div class="py-2">
            <div class="card">
                <div class="card-header">
                    <div class="row">
                        <div class="col-10 text-left">
                            <strong>Opções de caixa</strong>
                        </div>
                        <div class="col-2 text-right">
                            <font-awesome-icon icon="sync" @click="updatePage(false)" />
                        </div>
                    </div>
                </div>
                <div class="card-body">
                    <div class="row">
                        <dir class="col-md-5">
                            <div class="form-group text-left">
                                <b-form-datepicker 
                                    placeholder="Data do caixa" 
                                    v-model="dataCaixa" 
                                    class="mb-2" 
                                    locale="pt-br"
                                    size="sm"
                                />
                                <!-- <input type="date" id="idDataCaixa" v-model="dataCaixa" v-on:keyup.enter="updatePage()" class="form-control" > -->
                                <small id="emailHelp" class="form-text text-muted">Selecione a data para ver o resumo do caixa.</small>
                            </div>                            
                        </dir>
                        <dir class="col-md-5">
                            <!-- <div class="form-group text-left">
                                <b-form-input list="my-list-id"></b-form-input>

                                <datalist id="my-list-id">
                                    <option 
                                        v-for="usuario in usuarios" 
                                        :key="usuario.id"
                                        :value="usuario.id"
                                    >{{ usuario.nome }}</option>
                                </datalist>
                                <small id="emailHelp" class="form-text text-muted">Selecione o usuário para ver o resumo do caixa.</small>
                            </div>                  -->
                        </dir>
                        <div class="col-md-2">
                            <div class="form-group ">
                                <button class="btn btn-outline-secondary btn-block btn-sm" @click="updatePage(true)" >Alterar dia</button>                            
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" id="caixa-valores">
            <div class="col-md-6 py-2">
                <div class="card text-left">
                    <div class="card-header">
                        <strong>
                            Caixa - {{caixa.datacx}}
                        </strong>
                    </div>
                    <div class="card-body">
                        <h5>Sangria e suprimentos</h5>
                            <p>
                                <span>
                                    ( + ) Abertura do caixa
                                </span>
                                <span>
                                     {{formater(caixa.saldo_anterior)}}
                                </span>
                            </p>
                            <hr class="border-dotted" > 
                            <p>
                                <span>
                                    ( + ) Entradas no caixa
                                </span> 
                                <span>
                                    {{formater(caixa.suplemento)}}
                                </span>
                            </p>
                            <hr class="border-dotted" > 
                            <p>
                                <span>
                                    ( - ) Retiradas no caixa 
                                </span>
                                <span>
                                    {{formater(caixa.sangrias)}}
                                </span>
                            </p>

                            <hr class="border">

                        <h5>Recebimentos</h5>
                            <p>
                                <span>
                                    ( + ) Dinheiro 
                                </span>
                                <span>
                                    {{formater(caixa.tot_recebimentos)}}
                                </span>
                            </p>
                            <hr class="border-dotted" > 
                            <p>
                                <span>
                                    ( + ) Cheque 
                                </span>
                                <span>
                                    {{formater(caixa.tot_receb_chq)}}
                                </span>
                            </p>
                            <hr class="border-dotted" > 
                            <p>
                                <span>
                                    ( + ) Cartão 
                                </span>
                                <span>
                                    {{formater(caixa.tot_receb_car)}}
                                </span>
                            </p>
                            <hr class="border-dotted" > 
                            <p>
                                <span>
                                    ( + ) Banco 
                                </span>
                                <span>
                                    {{formater(caixa.tot_receb_ban)}}
                                </span>
                            </p>
                            <hr class="border-dotted" > 
                            <p>
                                <span>
                                    ( + ) Vale crédito 
                                </span>
                                <span>
                                    {{formater(caixa.tot_receb_cre)}}
                                </span>
                            </p>
                            <hr class="border-dotted" > 
                            <p>
                                <strong>Total: </strong>
                                {{formater(
                                    parseFloat(caixa.tot_recebimentos) + 
                                    parseFloat(caixa.tot_receb_chq) + 
                                    parseFloat(caixa.tot_receb_car) + 
                                    parseFloat(caixa.tot_receb_ban) +
                                    parseFloat(caixa.tot_receb_cre)
                                )}}
                            </p>

                            <hr class="border">

                        <h5>Pagamentos</h5>
                            <p>
                                <span>
                                    ( - ) Dinheiro 
                                </span>
                                <span>
                                    {{formater(caixa.tot_pagamentos)}}
                                </span>
                            </p>
                            <hr class="border-dotted" > 
                            <p>
                                <span>
                                    ( - ) Cheque 
                                </span>
                                <span>
                                    {{formater(caixa.tot_pagam_chq)}} 
                                </span>
                            </p>
                            <hr class="border-dotted" > 
                            <p>
                                <span>
                                    ( - ) Cartão 
                                </span>
                                <span>
                                    {{formater(caixa.tot_pagam_car)}}
                                </span>
                            </p>
                            <hr class="border-dotted" > 
                            <p>
                                <span>
                                    ( - ) Banco 
                                </span>
                                <span>
                                    {{formater(caixa.tot_pagam_ban)}}
                                </span>
                            </p>
                            <hr class="border-dotted" >
                            <p>
                                <strong>Total: </strong>
                                {{formater(
                                    parseFloat(caixa.tot_pagamentos) + 
                                    parseFloat(caixa.tot_pagam_chq) + 
                                    parseFloat(caixa.tot_pagam_car) + 
                                    parseFloat(caixa.tot_pagam_ban)
                                )}}
                            </p>

                            <hr class="border">

                        <h3>
                            <span>
                                Saldo Final:
                            </span>
                            {{formater(caixa.saldo_atual)}}
                        </h3>
                    </div>
                </div>
            </div>
            <div class="col-md-6 py-2">
                <div class="card text-left">
                    <div class="card-header">
                        <strong>
                            Faturamento
                        </strong>
                    </div>
                    <div class="card-body">
                        <h5>
                            Vendas e O.S.
                        </h5>
                            <p>
                                <span>
                                    ( + ) Dinheiro  
                                </span>
                                <span>
                                    {{formater(caixa.totais_avista)}}
                                </span>
                            </p>
                            <hr class="border-dotted" > 
                            <p>
                                <span>
                                    ( + ) Cheque a vista  
                                </span>
                                <span>
                                    {{formater(caixa.ven_chqbom)}}
                                </span>
                            </p>
                            <hr class="border-dotted" > 
                            <p>
                                <span>
                                    ( + ) Cartão de débito  
                                </span>
                                <span>
                                    {{formater(caixa.ven_cartao_d)}}
                                </span>
                            </p>
                            <hr class="border-dotted" > 
                            <p>
                                <span>
                                    ( + ) Cartão de crédito 
                                </span>
                                <span>
                                    {{formater(caixa.ven_cartao_c)}}
                                </span>
                            </p>
                            <hr class="border-dotted" > 
                            <p>
                                <span>
                                    ( + ) A prazo 
                                </span>
                                <span>
                                    {{formater(caixa.ven_aprazo)}}
                                </span>
                            </p>
                            <hr class="border-dotted" > 
                            <p>
                                <span>
                                    ( + ) Boleto 
                                </span>
                                <span>
                                    {{formater(caixa.ven_boleto)}}
                                </span>
                            </p>
                            <hr class="border-dotted" > 
                            <p>
                                <span>
                                    ( + ) Cheques pré-datado 
                                </span>
                                <span>
                                    {{formater(caixa.ven_chqpre)}}
                                </span>
                            </p>
                            <hr class="border-dotted" > 
                            <p>
                                <span>
                                    ( + ) Convênios 
                                </span>
                                <span>
                                    {{formater(caixa.ven_convenio)}}
                                </span>
                            </p>
                            <hr class="border-dotted" > 
                            <p>
                                <span>
                                    ( + ) Outros 
                                </span>
                                <span>
                                    {{formater(caixa.ven_outras)}}
                                </span>
                            </p>
                            <hr class="border-dotted" > 
                            <p>
                                <span>
                                    ( + ) Garantia 
                                </span>
                                <span>
                                    {{formater(caixa.ven_garantia)}}
                                </span>
                            </p>
                            <hr class="border-dotted" > 
                            <p>
                                <span>
                                    ( + ) Vale-Crédito 
                                </span>
                                <span>
                                    {{formater(caixa.ven_valecredito)}}
                                </span>
                            </p>
                            <hr class="border-dotted" > 
                            <hr class="border-dotted" > 
                            <p>
                                <strong>Total Geral</strong> 
                                {{formater(
                                    parseFloat(caixa.totais_avista) +
                                    parseFloat(caixa.ven_chqbom) +
                                    parseFloat(caixa.ven_cartao_d) +
                                    parseFloat(caixa.ven_cartao_c) +
                                    parseFloat(caixa.ven_aprazo) +
                                    parseFloat(caixa.ven_boleto) +
                                    parseFloat(caixa.ven_chqpre) +
                                    parseFloat(caixa.ven_convenio) +
                                    parseFloat(caixa.ven_outras) +
                                    parseFloat(caixa.ven_garantia) +
                                    parseFloat(caixa.ven_valecredito)
                                )}}
                            </p>

                        <hr class="border">

                        <h5>Total Geral</h5>
                            <p>
                                <span>
                                    Total a vista 
                                </span>
                                <span>
                                    {{formater(caixa.totais_os_avista)}}
                                </span>
                            </p>
                            <hr class="border-dotted" > 
                            <p>
                                <span>
                                    Total de cartões 
                                </span>
                                <span>
                                    {{formater((parseFloat(caixa.ser_cartao_c) + parseFloat(caixa.ser_cartao_d)))}}
                                </span>
                            </p> 
                            <hr class="border-dotted" > 
                            <p>
                                <span>
                                    Total a prazo 
                                </span>
                                <span>
                                    {{formater(caixa.totais_aprazo)}}
                                </span>
                            </p>
                            <hr class="border-dotted" > 
                            <p>
                                <span>
                                    Total (Garantia + Crédito) 
                                </span>
                                <span>
                                    {{formater((caixa.tot_garantia + caixa.tot_valecredito))}}
                                </span>
                            </p>
                            <hr class="border-dotted" > 
                            <p>
                                <span>
                                    Total de cancelamentos 
                                </span>
                                <span>
                                    {{formater(caixa.total_cancelados)}}
                                </span>
                            </p>
                            <hr class="border-dotted" > 
                            <p>
                                <span>
                                    Total de trocas/devoluções 
                                </span>
                                <span>
                                    {{formater(caixa.total_devolucoes)}}
                                </span>
                            </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'vwCashFluxByDay',
        data(){
            return {
                caixa: {
                    datacx : this.dataCaixa
                },
                dataCaixa: this.$moment().format('DD-MM-YYYY'),

                usuarios: [
                    {id: 1, nome: 'Witerlland'},
                    {id: 2, nome: 'Gestor'}
                ]
            }
        },
        computed: {
            getToken(){
                return this.$store.getters.getToken
            }
        },
        methods: {
            updatePage: function(val){
                let date;
                if(val === false){
                    date = this.$moment().format('DD-MM-YYYY')
                }else{
                    date = this.$moment(this.dataCaixa, 'YYYY-MM-DD').format('DD-MM-YYYY')
                }

                fetch(server + 'grides/caixa/fluxo/' + date, {
                    method: 'GET',
                    headers: new Headers({
                        'token' : this.getToken
                    })
                })
                    .then(response => (response.json()))
                    .then(responseJSON => {
                        if(responseJSON.data == true){
                            if(responseJSON.response.length > 0){
                                this.caixa = responseJSON.response[0]
                            }else{
                                this.caixa = []    
                            }
                        }else{
                            this.caixa = []
                        }
                    })
                    .catch(error => {
                        console.log('Error exception', '=>', error)
                    })
            },

            formater: function(value){
                if(value == null || value == undefined || isNaN(value)){
                    return 'R$ 0,00'
                }else{
                    const formatter = new Intl.NumberFormat('pt-br', {
                        style: 'currency',
                        currency: 'BRL',
                        minimumFractionDigits: 2
                    })

                    return formatter.format(value)
                }
            }
        },
        mounted(){
            // this.resetInputDate()
            this.updatePage(false)
        }
    }
</script>
<style scoped>
    .col-md-5{
        margin: 0 !important;
    }

    hr.border-dotted{
        border-style: dotted;
        margin: 0px !important;
        padding: 0px !important;
    }
    
    #caixa-valores p{
        margin: 0.2rem 0 !important;
    }

    #caixa-valores p,
    h3{
        display: flex;
        justify-content: space-between;
    }
</style>